module.exports = __webpack_public_path__ + "images/internal/review_widgets/theme/light_mode_icon.svg";